module.exports = __webpack_public_path__ + "img/logo.b1c8dd73.png";